CollectionWithHelpers = require 'models/collections/internal/collection-with-helpers'
PluginData = require 'models/plugin-data'
Promise = require 'bluebird'
_ = require 'underscore'
xtend = require 'xtend'

module.exports = class PluginDataList extends CollectionWithHelpers
  model: PluginData

  initialize: (models, options) ->
    @scopeModel = options.scopeModel

  scope: ->
    @scopeModel.typeName.toLowerCase()

  for: (idPlugin, visibility) ->
    _.find @models, (model) =>
      model.get('idPlugin') == idPlugin &&
      model.get('access') == visibility &&
      model.get('scope') == @scope() &&
      model.get('idModel') == @scopeModel.id

  create: (attributes, options) ->
    attributes = xtend attributes,
      scope: @scope()
      idModel: @scopeModel.id
      access: attributes.visibility

    super(attributes, options)

  dataForPlugin: (idPlugin) ->
    _.chain(@models)
    .filter (entry) -> entry.get('idPlugin') == idPlugin
    .groupBy (entry) -> entry.get('scope')
    .mapObject (val) ->
      _.chain(val)
      .groupBy (entry) -> entry.get('access')
      .mapObject (val) -> val[0].get('value')
      .value()
    .value()

  snoopDataForPlugin: (idPlugin) ->
    if !@signalCache?
      @signalCache = {}
    if !@signalCache[idPlugin]?
      @signalCache[idPlugin] = @snoop('value').map => @dataForPlugin(idPlugin)
      @signalCache[idPlugin].addDisposer => delete @signalCache[idPlugin]
    @signalCache[idPlugin]

  upsert: (idPlugin, visibility, data) ->
    pluginData = @for(idPlugin, visibility)
    if pluginData?
      pluginData.update('value', data)
    else
      @create
        idPlugin: idPlugin
        visibility: visibility
        value: data
    return



// WEBPACK FOOTER //
// ./app/scripts/models/collections/plugin-data-list.coffee